import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import RouteConstants from "../../../constants/routeConstants.json";
import { getAdminActivityLog } from "../../../api/Api";
import ContentData from "../../../constants/contentFile.json";
import { useCookies } from "react-cookie";
export const AdminActivityContext = createContext({});
export const AdminActivityContextProvider = ({ children }) => {
  const [adminActivityList, setAdminActivityList] = useState([]);

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  const adminActivityListShow = async (page) => {
    try {
      setSpinnerStatus(true);
      const getActivityList = await getAdminActivityLog(page);
      const logs = getActivityList?.data?.data?.logs;

      if (getActivityList?.status === 200) {
        if (logs.length > 0) {
          setSpinnerStatus(false);
          setAdminActivityList((prevLogs) => [...prevLogs, ...logs]);
          setCurrentPage(page);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
    setSpinnerStatus(false);
  };

  const adminToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const activityPageToList = () => {
    navigate(RouteConstants.ADMIN_LIST);
  };

  // close error modal
  const onHandleClose = () => {
    setErrorPopup(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  useEffect(() => {
    adminActivityListShow(currentPage);
  }, []);

  const providerValue = {
    adminActivityListShow,
    adminActivityList,
    adminToLogin,
    statusValue,
    buttonText,
    spinnerStatus,
    activityPageToList,
    errorPopup,
    errorPopupMessage,
    formatDate,
    formatTime,
    setErrorPopup,

    currentPage,
    hasMore,
  };
  return (
    <AdminActivityContext.Provider value={providerValue}>
      {children}
    </AdminActivityContext.Provider>
  );
};
